<template>
  <div>
    <mainVue>
      <template v-slot:main="main">
        <audioVue :data-list="main.data"></audioVue>
      </template>
    </mainVue>
  </div>
</template>

<script>

  import mainVue from '../../../components/resource/main.vue'
  import audioVue from '../../../components/resource/audio.vue';

  export default {
    name: 'PortalInBooks',
    components: {
      audioVue, mainVue
    },
    data() {
      return {};
    },

    mounted() {
    },

    methods: {},
  };
</script>

<style lang="less" scoped>

</style>
